import { render, staticRenderFns } from "./SalesNew.vue?vue&type=template&id=2482db1e&scoped=true&"
import script from "./SalesNew.vue?vue&type=script&lang=js&"
export * from "./SalesNew.vue?vue&type=script&lang=js&"
import style1 from "./SalesNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482db1e",
  null
  
)

export default component.exports